import { message } from "antd";
import React, { useEffect, useState } from "react";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";
import { Load } from "../../components/Load";
import { PermissionComponent } from "../../components/PermissionComponent";
import { useAuth } from "../../hooks/auth";
import { api } from "../../services/api";
import { Page } from "./styles";
interface UserInfo {
  id: string;
  name: string;
  email: string;
  cpfCnpj: string;
  password?: string;
}
interface CientInfo {
  id: string;
  name: string;
  corporateName?: string ;
  email: string;
  cpfCnpj: string;
  password?: string;
}
interface UpdateProps extends UserInfo, CientInfo{

}
const Profile = () => {
  const { user, updateUser  } = useAuth();
  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [name, setName] = useState("");
  const [corporateName, setCorporateName] = useState("");
  const [email, setEmail] = useState("");
  const [cpfCnpj, setCpfcnpj] = useState("");
  const [password, setPassword] = useState("");
  function fetchDataClient() {
    api.get<CientInfo>(`clients/${user.id}`).then((response) => {
      const user = response.data;
      setName(user.name)
      setEmail(user.email)
      setCpfcnpj(user.cpfCnpj)
      if(user.corporateName)
      setCorporateName(user.corporateName)
    }).finally(()=> setLoading(false));
  }
  function fetchDataUser() {
    api.get<UserInfo>("users/me").then((response) => {
      const user = response.data;
      setName(user.name)
      setEmail(user.email)
      setCpfcnpj(user.cpfCnpj)
    }).finally(()=> setLoading(false));
  }
  function fetchData() {
  return user.type === 'USER' ? fetchDataUser() : fetchDataClient();
  }
  function handleUpdateUserData(user:UserInfo) {
    setLoadingBtn(true)
    api.put('users',user).then(()=>{
      message.success('Usuário atualizado com sucesso!');
      updateUser({
        id: user.id,
        name: user.name,
        email: user.email
      })
    }).catch((e)=>{
      message.error(e.response.data.message)
    }).finally(()=> setLoadingBtn(false));
  }
  function handleUpdateClient(client:CientInfo) {
    setLoadingBtn(true)
    api.put('clients',client).then(()=>{
      message.success('Cliente atualizado com sucesso!');
      updateUser({
        id: user.id,
        name: user.name,
        email: user.email,
      })
    }).catch((e)=>{
      message.error(e.response.data.message)
    }).finally(()=> setLoadingBtn(false));
  }
  function update(data:UpdateProps) {
    return user.type === 'USER' ? handleUpdateUserData(data) : handleUpdateClient(data)
  }
  function handleUpdateUser() {
    if(!name || !email){
      return message.info('Preencha todos os dados marcados com *');
    }
    update({
      name,
      email,
      id: user.id,
      cpfCnpj,
      corporateName,
      password: password ? password : undefined
    })
    
    
  }
  useEffect(fetchData, []);
  return (
    <Page>
      <header>
        <span>Perfil</span>
        <div className="buttons">
          <Button title="Atualizar" loading={loadingBtn} onClick={handleUpdateUser} />
        </div>
      </header>
      <div className="content">
        {loading ? (
          <div className="loading">
            <Load />
          </div>
        ) : (
          <>
            <div className="descriptions">
              <span>Nome:*</span>
              <PermissionComponent type="CLIENT">
              <span>Nome Corporativo:*</span>
              </PermissionComponent>
              <span>Email:*</span>
              <span>CPF/CNPJ:</span>
              <span>Senha:</span>
            </div>
            <div className="inputs">
              <Input
                placeholder="Digite um nome..."
                value={name}
                onChange={(ev) => setName(ev.currentTarget.value)}
              />
              <PermissionComponent type="CLIENT">
              <Input
                placeholder="Digite um nome corporativo..."
                value={corporateName}
                onChange={(ev) => setCorporateName(ev.currentTarget.value)}
              />
              </PermissionComponent>
              <Input
                placeholder="Digite um email..."
                value={email}
                onChange={(ev) => setEmail(ev.currentTarget.value)}
              />
              <Input
                placeholder="Digite um CPF ou CNPJ..."
                value={cpfCnpj}
                onChange={(ev) => setCpfcnpj(ev.currentTarget.value)}
              />
              <Input
                placeholder="Digite uma senha..."
                type="password"
                value={password}
                onChange={(ev) => setPassword(ev.currentTarget.value)}
              />
            </div>
          </>
        )}
      </div>
    </Page>
  );
};
export { Profile };
